import { PageHero } from "@/pages/About";

export default function Privacy() {
    return (
        <div>
            <PageHero title="Privacy Policy" subtitle="How we handle your information" />
            <section className="gsf-section" data-testid="privacy-content">
                <div className="gsf-container max-w-3xl space-y-6 text-[color:var(--gsf-body)] leading-relaxed">
                    <p>
                        Global Seed Foundation is committed to protecting the personal information you share with us.
                        We collect only the information necessary to respond to your enquiry, deliver programme
                        activities or provide the services you request.
                    </p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold mt-8">Information we collect</h3>
                    <p>Contact details (name, email, phone), enquiry information you provide voluntarily, and technical data such as IP address and browser type for security and analytics.</p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">How we use information</h3>
                    <p>To respond to enquiries, deliver programmes, provide referrals with your consent, and communicate updates you have subscribed to.</p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">How we protect information</h3>
                    <p>Data is transmitted over HTTPS, stored in access-controlled databases, and reviewed only by authorised administrators. Sensitive personal information is never displayed publicly.</p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">Your choices</h3>
                    <p>You may request access to, correction of, or deletion of your information by writing to impact@globalseedzim.org.</p>
                    <p className="text-sm text-gray-500">This policy will be periodically updated. The most recent version is always available on this page.</p>
                </div>
            </section>
        </div>
    );
}
